import * as React from 'react';
import { RouteObject } from 'react-router-dom';

const ClientSurveys = React.lazy(
    () => import(/* webpackChunkName: "client-surveys" */ '../../../../containers/Client/Surveys')
);
const ClientResponsesTable = React.lazy(
    () =>
        import(
            /* webpackChunkName: "client-surveys-responses" */ '../../../../containers/Client/Surveys/children/ResponsesTable'
        )
);
const ClientResponse = React.lazy(
    () =>
        import(
            /* webpackChunkName: "client-surveys-response" */ '../../../../containers/Client/Surveys/children/Response'
        )
);

export const ClientSurveysRoutes: RouteObject = {
    path: 'surveys',
    element: (
        <React.Suspense fallback={<>...</>}>
            <ClientSurveys />
        </React.Suspense>
    ),
    children: [
        {
            index: true,
            element: (
                <React.Suspense fallback={<>...</>}>
                    <ClientResponsesTable />
                </React.Suspense>
            )
        },
        {
            path: 'survey/:surveyId',
            element: (
                <React.Suspense fallback={<>...</>}>
                    <ClientResponse />
                </React.Suspense>
            )
        }
    ]
};
